import { useUsers } from "@app/screens/Users/data";
import { Avatar } from "@design-system/DataDisplay/Avatar";
import { Tooltip } from "@design-system/DataDisplay/Tooltip";
import { FlexRow } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { FC } from "react";

export const AssigneesUserAvatar: FC<{
    userIds: Set<string>;
    truncateAfter?: number;
}> = ({ userIds, truncateAfter = 4 }) => {
    const users = useUsers();
    const assignees =
        users.data?.users.filter((user) => userIds.has(user.id)) ?? [];

    return (
        <FlexRow alignItems="center" gap="1">
            <FlexRow alignItems="center" className="-space-x-1">
                {assignees?.slice(0, truncateAfter).map((user, index) => (
                    <Tooltip key={index}>
                        <Tooltip.Trigger asChild>
                            <Avatar
                                className="border border-white"
                                variant="circle"
                                size="sm"
                                imageUrl={user?.avatar?.signedUrl}
                                letter={user.firstName.charAt(0)}
                            />
                        </Tooltip.Trigger>
                        <Tooltip.Content>
                            <Text variant="body-sm-bold">
                                {user.firstName} {user.lastName}
                            </Text>
                        </Tooltip.Content>
                    </Tooltip>
                ))}
            </FlexRow>
            {assignees?.length > truncateAfter && (
                <Text variant="body-sm-bold">
                    +{assignees.slice(truncateAfter).length}
                </Text>
            )}
        </FlexRow>
    );
};
